// src/debugLog.js

export function debugLog(...args) {
  try {
    const flag = window.localStorage.getItem('__debug_logs_enabled');
    if (flag === '1') {
		// pgw 08-oct-2025 - for now (and for release) remove console.log() calls, as I can't get debug flag logic to work...
		// console.log(...args);
    }
  } catch (e) {
    // fallback: just ignore
  }
}

